import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { Slot } from '@costar-ui/components';
import { cn } from '@costar-ui/cosmos';
import React__default, { useMemo } from 'react';

var _excluded = ["children", "direction", "gap", "alignItems", "justify", "responsive", "className"];
var Caption = function Caption(_ref) {
  var children = _ref.children,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
    _ref$gap = _ref.gap,
    gap = _ref$gap === void 0 ? 'lg' : _ref$gap,
    alignItems = _ref.alignItems,
    _ref$justify = _ref.justify,
    justify = _ref$justify === void 0 ? 'start' : _ref$justify,
    responsive = _ref.responsive,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var responsiveClassNames = useMemo(function () {
    return responsive ? 'flex-[50%]' : 'flex-1';
  }, [responsive]);
  if (!children) return null;
  return /*#__PURE__*/React__default.createElement(Slot, _extends({
    as: "figcaption",
    direction: direction,
    className: cn('csg-tw-info-card-details h-max overflow-hidden', responsiveClassNames, className),
    gap: gap,
    fullWidth: true,
    alignItems: alignItems,
    justify: justify
  }, rest), children);
};
Caption.displayName = 'Caption';
var Caption$1 = Caption;

export { Caption$1 as default };
//# sourceMappingURL=caption.esm.js.map
